// extracted by mini-css-extract-plugin
export default {"container":"Configuracion_container__YqYpn","title":"Configuracion_title__TAwPV"};